(function() {
    const section = document.querySelector('.grow-poll');
    if (!section) return;
    const wrap = section.querySelector('.grow-poll__response-wrap');
    const chips = section.querySelectorAll('.grow-poll__chip');
    const responses = section.querySelectorAll('.grow-poll__response');

    function closeAll() {
      chips.forEach(c => c.setAttribute('aria-pressed', 'false'));
      responses.forEach(r => r.setAttribute('hidden', ''));
      if (wrap) wrap.classList.remove('is-open');
      section.classList.remove('is-open');
    }

    function openCrop(crop) {
      chips.forEach(c => c.setAttribute('aria-pressed', c.dataset.crop === crop ? 'true' : 'false'));
      responses.forEach(r => {
        if (r.dataset.crop === crop) r.removeAttribute('hidden');
        else r.setAttribute('hidden', '');
      });
      if (wrap) wrap.classList.add('is-open');
      section.classList.add('is-open');
    }

    chips.forEach(chip => {
      chip.addEventListener('click', () => {
        const isActive = chip.getAttribute('aria-pressed') === 'true';
        if (isActive) closeAll();
        else openCrop(chip.dataset.crop);
      });
      chip.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { closeAll(); chip.blur(); return; }
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        const arr = Array.from(chips);
        const idx = arr.indexOf(chip);
        const next = e.key === 'ArrowRight'
          ? arr[(idx + 1) % arr.length]
          : arr[(idx - 1 + arr.length) % arr.length];
        next.focus();
      });
    });
  })();
  

/* ===== homepage script block ===== */

    /* =========================================================
       Parallax — translate the banner's BG element on scroll.
       Throttled with requestAnimationFrame. Disabled by
       prefers-reduced-motion (CSS handles that branch).
       ========================================================= */
    (function() {
      const bgs = document.querySelectorAll('[data-parallax]');
      if (!bgs.length) return;
      const pairs = Array.from(bgs).map(bg => ({ bg, section: bg.parentElement }));
      let ticking = false;

      function update() {
        const vh = window.innerHeight;
        pairs.forEach(({ bg, section }) => {
          const rect = section.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top < vh) {
            const sectionCenter = rect.top + rect.height / 2;
            const viewportCenter = vh / 2;
            const offset = (sectionCenter - viewportCenter) * -0.12;
            bg.style.transform = `translateY(${offset}px)`;
          }
        });
        ticking = false;
      }

      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }, { passive: true });

      update();
    })();
  

/* ===== homepage script block ===== */

  (function() {
    /* ---------- Real Homes info button (disclaimer popup) ---------- */
    var infoBtn = document.querySelector('.real-homes-info');
    var infoPop = document.querySelector('.real-homes-disclaimer-pop');
    if (infoBtn && infoPop) {
      function closePop() {
        infoPop.setAttribute('hidden', '');
        infoBtn.setAttribute('aria-expanded', 'false');
      }
      function openPop() {
        infoPop.removeAttribute('hidden');
        infoBtn.setAttribute('aria-expanded', 'true');
      }
      infoBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        if (infoPop.hasAttribute('hidden')) openPop();
        else closePop();
      });
      document.addEventListener('click', function(e) {
        if (infoPop.hasAttribute('hidden')) return;
        if (!infoPop.contains(e.target) && e.target !== infoBtn) closePop();
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && !infoPop.hasAttribute('hidden')) {
          closePop();
          infoBtn.focus();
        }
      });
    }

    /* ---------- Real Homes lightbox ---------- */
    var lightbox = document.getElementById('real-homes-lightbox');
    if (!lightbox) return;
    var lightboxImg = lightbox.querySelector('img');
    var closeBtn = lightbox.querySelector('.lightbox-close');
    var lastFocused = null;

    function openLightbox(src, alt) {
      if (!src) return;
      lastFocused = document.activeElement;
      lightboxImg.src = src;
      lightboxImg.alt = alt || '';
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }
    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      lightboxImg.src = '';
      document.body.style.overflow = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    /* Click handler — delegated so duplicated marquee cards also trigger */
    document.addEventListener('click', function(e) {
      var card = e.target.closest('.real-home-card');
      if (card) {
        var src = card.getAttribute('data-full-src');
        var img = card.querySelector('img');
        var alt = card.getAttribute('aria-label') || (img && img.alt) || '';
        if (!src && img) src = img.src;
        if (src) openLightbox(src, alt);
        return;
      }
      if (e.target === lightbox || e.target === closeBtn) closeLightbox();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
    });
  })();
  

/* ===== homepage script block ===== */

  (function() {
    const chips = document.querySelectorAll('.grow-poll__chip');
    const responses = document.querySelectorAll('.grow-poll__response');

    function selectCrop(crop) {
      chips.forEach(chip => {
        const isActive = chip.dataset.crop === crop;
        chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      responses.forEach(resp => {
        if (resp.dataset.crop === crop) {
          resp.removeAttribute('hidden');
        } else {
          resp.setAttribute('hidden', '');
        }
      });
    }

    chips.forEach(chip => {
      chip.addEventListener('click', () => selectCrop(chip.dataset.crop));
      /* Keyboard nav — left/right arrows move between chips */
      chip.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        const arr = Array.from(chips);
        const idx = arr.indexOf(chip);
        const next = e.key === 'ArrowRight'
          ? arr[(idx + 1) % arr.length]
          : arr[(idx - 1 + arr.length) % arr.length];
        next.focus();
        selectCrop(next.dataset.crop);
      });
    });
  })();
  

/* ===== homepage script block ===== */

  /* Hero feature groups: open by default on desktop (the label looks like
     a static eyebrow + items below). On mobile they collapse into leaf-
     shaped buttons. Sync the `open` attribute to viewport on load + resize. */
  (function syncHeroFeatureGroups() {
    const groups = document.querySelectorAll('.hero-feature-group');
    if (!groups.length) return;
    const mq = window.matchMedia('(max-width: 720px)');
    const sync = () => {
      groups.forEach(g => {
        if (mq.matches) g.removeAttribute('open');
        else g.setAttribute('open', '');
      });
    };
    sync();
    // Use addEventListener('change') on the MediaQueryList — fires only when
    // crossing the breakpoint, not on every resize pixel
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else mq.addListener(sync);  // Safari < 14 fallback
  })();

  /* Three-layers "Read more" pillar toggles (Suzy R2: were unwired) */
  (function pillarReadMore() {
    var btns = document.querySelectorAll('.pillar-toggle');
    if (!btns.length) return;
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        var id = btn.getAttribute('aria-controls');
        var body = id && document.getElementById(id);
        if (body) body.classList.toggle('is-expanded', !expanded);
      });
    });
  })();

  /* F-199 (Suzy, 2026-08-09): the three-layers lede is static; the typewriter reveal was removed on C-2163. */

  /* Four-steps: tap/click/Enter to flip a card to its purple detail back (Suzy R2) */
  (function fourStepsFlip() {
    var cards = document.querySelectorAll('.hiw-card');
    if (!cards.length) return;
    cards.forEach(function (card) {
      function toggle() {
        var flipped = card.classList.toggle('is-flipped');
        card.setAttribute('aria-pressed', String(flipped));
      }
      card.addEventListener('click', toggle);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); toggle(); }
      });
    });
  })();

  /* Pre-order promo bar: rotate through the announcement messages (Suzy R2) */
  (function promoRotator() {
    var track = document.querySelector('[data-promo-rotator]');
    if (!track) return;
    var msgs = track.querySelectorAll('.promo-bar__msg');
    if (msgs.length < 2) return;
    var i = 0, timer = null;
    function show(n) {
      msgs[i].classList.remove('is-active');
      i = (n + msgs.length) % msgs.length;
      msgs[i].classList.add('is-active');
    }
    function start() { timer = setInterval(function () { show(i + 1); }, 5000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    start();
    var bar = track.closest('.promo-bar');
    if (bar) {
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
    }
  })();

  /* [data-open-chat] opens the on-site support chat instead of navigating
     (falls back to the link's href if the widget isn't present). */
  (function () {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-open-chat]');
      if (!trigger) return;
      var root = document.querySelector('#nt-chat');
      var bubble = root && root.querySelector('.nt-chat__bubble');
      if (!bubble) return;                 // no widget -> let the href work
      e.preventDefault();
      if (!root.classList.contains('is-open')) bubble.click();
      root.scrollIntoView({ block: 'nearest' });
    });
  })();
